<template>
  <div class="mh100vh b_fff">
    <div class="profit pt20 pl24 pr24">
      <div class="bg1 pt30 pl24 pr24 b_red c_fff bdrd8">
        <div class="df aic">
          <div class="fz40 fx1">收益余额：{{info.yongjin}}</div>
          <div @click="tixian" class="w136 lh46 b_red2 fz28 tac bdrd50 df aic jcc">
            提现
            <img src="./assets/img/arrow.png" alt="" class="db w14 h23 ml8">
          </div>
        </div>
        <div class="pt50 pb30 df aic jcsa tac">
          <div class="item">
            <div class="fz30">{{info.withdraw>=0?info.withdraw:'-'}}</div>
            <div class="mt8 fz24">可提现</div>
          </div>
          <div class="b_d8 w1 h60"></div>
          <div class="item">
            <div class="fz30">{{info.total>=0?info.total:'-'}}</div>
            <div class="mt8 fz24">累计收入</div>
          </div>
          <div class="b_d8 w1 h60"></div>
          <router-link :to="{ name: 'invitation' }" class="item c_fff">
            <div class="fz30">{{info.invite>=0?info.invite:'-'}}</div>
            <div class="mt8 fz24">邀请人数</div>
          </router-link>
        </div>
      </div>

      <div class="app-num-list">
        <div class="pt40 fz30 c_999 ovh tac">
          <div @click="choose(1)" :class="type==1?'cur c_333':''" class="fl mr50">
            收入记录
            <div :class="type==1?'b_red':''" class="m0a mt10 w60 h6 bdrd3"></div>
          </div>
          <div @click="choose(2)" :class="type==2?'cur c_333':''" class="fl">
            提现记录
            <div :class="type==2?'b_red':''" class="m0a mt10 w60 h6 bdrd3"></div>
          </div>
        </div>
        <div v-if="list.length > 0" class="mt24 b_fff bdrd8 bsh1">
          <div v-if="type==1">
            <div v-for="(v,k) in list" class="lnb df aic pl24 pr24 pt30 pb30">
              <img v-if="v.photo" :src="v.photo" alt="" class="db all87 bdrd50p">
              <img v-else src="./assets/img/p.png" alt="" class="db all87 bdrd50p">
              <div class="pl16 fx1">
                <div class="fz30 c_333">{{v.nickname}}</div>
                <div class="mt4 fz24 c_999">{{v.created_at}}</div>
              </div>
              <!-- {{v.category}} 类型 -->
              <div>
                <div class="fz40 c_333 tar">+{{v.money}}元</div>
                <div class="c_666 tar">洗衣消费</div>
              </div>
            </div>
          </div>
          <div v-if="type==2">
            <div v-for="(v,k) in list" class="lnb df aic pl24 pr24 pt30 pb30">
              <div class="pl16 fx1">
                <div class="fz30 c_333 df aic">
                  提现到
                  <span v-if="v.category==1">余额</span>
                  <span v-if="v.category==2">微信</span>
                  <span v-if="v.category==3">支付宝</span>
                  <span v-if="v.status==1||v.status==3" class="ml12 tac w96 lh41 dib b_red c_fff fz22 bdrd50">
                    <span v-if="v.status==1">申请中</span>
                    <span v-if="v.status==3">驳回</span>
                  </span>
                </div>
                <div class="mt4 fz24 c_999">{{v.created_at}}</div>
              </div>
              <!-- {{v.category}} 类型 -->
              <div>
                <div class="fz40 c_333 tar">-{{v.money}}元</div>
                <div class="c_666 tar">剩余：{{v.balance}}元</div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="fz26 c_ccc pt40 tac">暂无数据</div>

        <!-- <div v-if="list.length > 0" class="weui-cells">
          <div v-for="(v,k) in list" v-bind:key="k" class="weui-cell">
              <div class="weui-cell__bd">
                  <p class="tit">{{v.note}}</p>
                  <p class="time">{{v.updated_at}}</p>
              </div>
              <div class="weui-cell__ft num" :class="[v.point>=0?'add':'minus']">{{v.point}}</div>
          </div>
      </div>
      <div v-else class="nodata">暂无数据</div> -->
      </div>

      <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10"></div>
    </div>
  </div>
</template>

<script>
import weui from 'weui.js'
import infiniteScroll from '@/basic/infiniteScroll'
export default {
  directives: { infiniteScroll },
  data() {
    return {
      account: {},
      info: {},
      list: [],
      busy: true,
      load: true,
      page: 1,
      type: 1
    }
  },
  mounted() {
    // weui.topTips('会员已到期，为了保证您的分销服务正常使用，请尽快续费',1500)
    this.getAccount();
  },
  methods: {
    tixian() {
      // weui.topTips('会员已到期，请续费后再进行操作')
      this.$router.push({ name: 'withdrawal' })
    },
    getAccount() {
      let vm = this;
      vm.ajax("account", "get", '', e => {
        vm.account = e.data;

        //判断会员是否到期 //TODO
        vm.getYongjin();
        vm.getLog();
      })
    },
    getYongjin() {
      let vm = this;
      vm.ajax("account/yongjin", "get", '', e => {
        vm.info = e.data;
      })
    },
    choose(type) {
      let vm = this;
      vm.type = type;
      vm.list = [];
      vm.page = 1;
      vm.getLog();
    },
    getLog(flag) {
      let vm = this;
      let url;
      if (vm.type == 1) url = "account/yongjin/log"
      if (vm.type == 2) url = "account/yongjin/withdraw"
      vm.ajax(url, "get", 'page=' + vm.page, e => {
        // e.data.list = [
        //   {
        //     id:1,created_at:'2015-05-52',money:100,blance:1000,status:1,category:20
        //   }
        // ]
        vm.load = false;
        if (e.data.list) {
          if (flag) {
            vm.list = vm.list.concat(e.data.list)
            if (e.data.count == vm.page) {
              vm.busy = true;
            } else {
              vm.busy = false;
            }
          } else {
            vm.list = e.data.list;
            if (vm.list.length < e.data.limit) {
              vm.busy = true;
            } else {
              vm.busy = false;
            }
          }
        } else {
          vm.busy = true;
        }
      })
    },
    loadMore() {
      let vm = this;
      vm.busy = true;
      vm.load = true;
      setTimeout(() => {
        vm.page++;
        vm.getAccountPointLog(true);
      }, 1000);
    }
  }
}
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/profit.vue